(function() {
    /* globals $, angular, Highcharts */
    'use strict';

    var start = function() {
        angular.element(document).ready(function() {
            angular.bootstrap(document, ['dashboardApp']);
        });
    };


    var initCharting = function() {
        Highcharts.setOptions({
            legend: {
                itemStyle: {
                    fontWeight: 'normal'    // see http://api.highcharts.com/highcharts#legend.itemStyle
                }
            },
            tooltip: {
                enabled: window.navigator.userAgent.toLowerCase().indexOf('ipad') === -1
            },
            plotOptions: {
                series: {
                    animation: false
                }
            },
            lang: {
                thousandsSep: ','
            },
            credits: { enabled: false }
        });
    };



    $(function() {
        initCharting();
        start();
    });



})();
